<template>
  <component :is="tag" class="button button--secondary caret-button">
    <slot />
    <Caret />
  </component>
</template>

<script>
  import { defineComponent } from '@vue/composition-api'
  import Caret from '@/components/icons/Caret'

  export default defineComponent({
    components: { Caret },
    props: {
      tag: {
        type: String,
        default: 'button',
      },
    },
  })
</script>

<style lang="scss" scoped>
  .caret-button {
    display: block;

    &[aria-expanded] {
      .icon {
        transform: rotate(0);
      }
    }

    .icon {
      height: 1.3em;
      margin-bottom: -0.25em;
      transform: rotate(180deg);
      transition: transform 0.1s ease-out;
      transform-origin: 50% 55%;
      pointer-events: none;
    }
  }
</style>
